module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_University-Admissions_Poster-e1155286998a75b11d79f6f9c11dca6c.jpg";